import {ApolloClient, gql} from '@apollo/client';
import {errorResponse, loadingResponse, NetworkRequestStatus, NetworkResult} from './NetworkResult';
import {ExportedWorkout} from '../Models/ExportedWorkout';
import {ca} from 'date-fns/locale';

export class ExportService {
    constructor(private client: ApolloClient<any>) {}

    public async forWorkoutId(
        workoutId: number,
        type: 'json' | 'csv' | 'tcx',
    ): Promise<NetworkResult<ExportedWorkout>> {
        try {
            let response: NetworkResult<ExportedWorkout> = loadingResponse();
            do {
                response = await this.query(workoutId, type);
                if (response.status === NetworkRequestStatus.Loading) {
                    await new Promise((resolve) => setTimeout(resolve, 1000));
                }
            } while (response.status === NetworkRequestStatus.Loading);

            return response;
        } catch (e) {
            console.error(e);
            return errorResponse();
        }
    }

    private async query(workoutId: number, type: 'json' | 'csv' | 'tcx'): Promise<NetworkResult<ExportedWorkout>> {
        try {
            const apolloQueryResult = await this.client.query({
                query: gql`
                    query ($workoutId: Int!, $type: FileType!) {
                        download(type: $type, workout_id: $workoutId, auth: ajax) {
                            id
                            status
                            type
                            link
                        }
                    }
                `,
                variables: {
                    workoutId,
                    type,
                },
                fetchPolicy: 'network-only',
            });

            if (apolloQueryResult.errors) {
                return errorResponse();
            }

            if (apolloQueryResult.data.download.status === 'preparing') {
                return {
                    status: NetworkRequestStatus.Loading,
                };
            }

            return {
                status: NetworkRequestStatus.Success,
                data: {
                    url: apolloQueryResult.data.download.link,
                },
            };
        } catch (e) {
            console.error(e);
            return errorResponse();
        }
    }
}
